module.exports = __webpack_public_path__ + "static/organiczoo-95b6a121471c6a5cd8a1fa500f276f32.jpeg";